module.exports = __webpack_public_path__ + "img/norwegian.51f62de.png";